import React from 'react';
import PropTypes from 'prop-types';

import PaymentMethodDefaultDetails from './PaymentMethodDefaultDetails/PaymentMethodDefaultDetails';
import PaymentMethodButtons from './PaymentMethodButtons/PaymentMethodButtons';

/**
 * PaymentMethodActions component.
 *
 * @property {boolean} displayDeleteButton - Whether to display the "Delete" button.
 * @property {function} handleSetDefaultPayment - Callback function to handle setting the payment method as default.
 * @property {boolean} [isDefault] - Indicates if the payment method is currently set as default (optional).
 * @property {boolean} [isSummaryPage] - Indicates if the component is rendered on the summary page (optional).
 * @property {string} [nextInvoiceDate] - The date of the next invoice (optional).
 * @property {function} toggleDeleteDialog - Callback function to toggle the delete confirmation dialog.
 */
const PaymentMethodActions = ({
  displayDeleteButton,
  handleSetDefaultPayment,
  isDefault,
  isSummaryPage,
  nextInvoiceDate,
  toggleDeleteDialog,
}) => (
  <div data-testid="BillingLicensing-PaymentMethodActions">
    <PaymentMethodDefaultDetails
      isDefault={isDefault}
      isSummaryPage={isSummaryPage}
      nextInvoiceDate={nextInvoiceDate}
    />
    <PaymentMethodButtons
      displayDeleteButton={displayDeleteButton}
      handleSetDefaultPayment={handleSetDefaultPayment}
      isDefault={isDefault}
      isSummaryPage={isSummaryPage}
      toggleDeleteDialog={toggleDeleteDialog}
    />
  </div>
);

PaymentMethodActions.defaultProps = {
  isDefault: false,
  isSummaryPage: false,
  nextInvoiceDate: '',
};

PaymentMethodActions.propTypes = {
  displayDeleteButton: PropTypes.bool.isRequired,
  handleSetDefaultPayment: PropTypes.func.isRequired,
  isDefault: PropTypes.bool,
  isSummaryPage: PropTypes.bool,
  nextInvoiceDate: PropTypes.string,
  toggleDeleteDialog: PropTypes.func.isRequired,
};

export default PaymentMethodActions;
